
interface ProjectListProps {
  children: React.ReactNode;
}

export default function ProjectList({ children }: ProjectListProps) {
  return <div className="project-list">{children}</div>;
}
